/* import __COLOCATED_TEMPLATE__ from './disclaimer.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './disclaimer.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsGoodFaithEstimateDisclaimer extends Component {}
